import React from 'react';
import { CheckIcon } from 'lucide-react';
import { includes } from '../data/content';
export function IncludesSection() {
  return <section aria-labelledby="incluye" className="border-y border-court-700/60 bg-court-900/40" data-id="element-119" data-mp="2drkl70x8lzs7">
      <div className="mx-auto max-w-5xl px-5 py-14 sm:py-16" style={{
      paddingTop: "13px",
      paddingBottom: "23px"
    }} data-id="element-120" data-mp="28y84re2pozaj">
        <h2 id="incluye" className="text-center font-display text-2xl uppercase text-white sm:text-3xl" data-id="element-121" data-mp="23ylt392j7r3u">
          Esto lo tienes desde el primer día
        </h2>
        <ul className="mx-auto mt-8 grid max-w-3xl gap-4 sm:grid-cols-2" data-id="element-122" data-mp="1uyyron9sylas">
          {includes.map(item => <li key={item} className="flex items-start gap-3" data-id="element-123" data-mp="1q1gegkor5jwz">
              <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-ball-400" data-id="element-124" data-mp="1l1u4ql84ulsx">
                <CheckIcon className="h-4 w-4 text-ink-900" aria-hidden="true" strokeWidth={3} data-id="element-125" data-mp="3key7uobu9azx" />
              </span>
              <span className="text-[15px] leading-relaxed text-slate-200" data-id="element-126" data-mp="3fgwo016l97ne">{item}</span>
            </li>)}
        </ul>
      </div>
    </section>;
}